import { useLevel1SectionData } from "../useLevel1Section";

const generalSections = ['check_engine_light', 'abs_light', 'air_bag_light', 'any_other_lights_on'];

export const useDashSections = () => {
  const { subSections } = useLevel1SectionData('interior_questions');

  return generalSections.map(key => subSections[key]).filter(Boolean);
};
